import React, { useEffect, useState } from "react";
import styles from "./LocationSelector.module.css";
import LocationButton from "./LocationButton";
import Header from "../../Header/Header";
import { useNavigate } from "react-router-dom";
import { deleteApi, getApi } from "../../AppApis";
import config from "../../../config";
import SettingHeader from "../../../components/SettingPageHeader/SettingHeader";
import Balls from "../../Templates/Loading";
import { toast } from "react-toastify";
import { showErrorToast, showSuccessToast } from "../../utils";

const LocationSelector = () => {
    const navigate = useNavigate();
    const [saveSearchesList, setSaveSearchesList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        document.title = `Saved Searches | ${config.get("COMPANY_NAME")}`;
        getSavedSearches();
    }, []);
    const getSavedSearches = async () => {
        setIsLoading(true);
        try {
            const response = await getApi("/notifications/saved_searches");
            if (response.error) {
                setSaveSearchesList([]);
            } else {
                setSaveSearchesList(response.response?.data?.saved_searches);
            }
        } catch (error) {
            console.log("ERror::", error);
        } finally {
            setIsLoading(false);
        }
    };
    const onDelete = async (item) => {
        try {
            const response = await deleteApi("/notifications/saved_searches/" + item.id);
            if (response.detail) {
                showErrorToast(`Error while deleting ${response.detail}`, { autoClose: 3000, pauseOnHover: false });
            } else {
                showSuccessToast("Search deleted successfully", { autoClose: 3000, pauseOnHover: false });
                getSavedSearches();
            }
        } catch (error) {
            showErrorToast(`Error while deleting ${error}`, { autoClose: 3000, pauseOnHover: false });
        }
    };

    const handleSearchClick = (searchData) => {
        // Navigate to properties page with search parameters
        navigate("/properties", {
            state: {
                searchLocation: searchData.description,
                latitude: parseFloat(searchData.latitude),
                longitude: parseFloat(searchData.longitude),
                applySearch: true,
            },
        });
    };

    const handleCopySearch = async (searchData) => {
        try {
            await navigator.clipboard.writeText(searchData.description);
            showSuccessToast("Search copied to clipboard!", { autoClose: 2000, pauseOnHover: false });
        } catch (error) {
            // Fallback for older browsers
            const textArea = document.createElement("textarea");
            textArea.value = searchData.description;
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand("copy");
                showSuccessToast("Search copied to clipboard!", { autoClose: 2000, pauseOnHover: false });
            } catch (fallbackError) {
                showErrorToast("Failed to copy search", { autoClose: 3000, pauseOnHover: false });
            }
            document.body.removeChild(textArea);
        }
    };
    return (
        <div className="tw-bg-background_color tw-h-screen">
            <Header title="Saved Searches" />
            <section className=" tw-flex-1  tw-p-[20px] ">
                <SettingHeader title="Saved Searches" />

                <section className={`${styles.content} tw-p-[20px]`}>
                    <div className={`${styles.buttonContainer} tw-flex-col`}>
                        <header className={styles.sectionHeader}>
                            <h2 className="tw-text-[18px] tw-font-semibold">Recent Searches</h2>
                            {/* <p className={styles.sectionDescription}>
                                Keep your account secure by updating your password regularly. A strong password protects your personal information.
                            </p> */}
                        </header>
                        {isLoading && (
                            <div className="tw-w-full tw-flex tw-justify-center tw-items-center">
                                <Balls></Balls>
                            </div>
                        )}
                        {!isLoading && saveSearchesList?.length === 0 && <div className="tw-text-center tw-mt-10 tw-w-full">No Saved Searches</div>}
                        <div className={styles.buttonWrapper}>
                            {saveSearchesList &&
                                saveSearchesList?.map((location, index) => (
                                    <LocationButton
                                        key={index}
                                        onDelete={() => onDelete(location)}
                                        onClick={() => handleSearchClick(location)}
                                        onCopy={() => handleCopySearch(location)}
                                        name={location.description}
                                        iconSrc={location.iconSrc}
                                    />
                                ))}
                        </div>
                    </div>
                </section>
            </section>
        </div>
    );
};

export default LocationSelector;
